module.exports = __webpack_public_path__ + "static/media/fal_fal_net_bea_bag.22e6c43e.png";